/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchDisputedTxnList } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchDisputedTxnList = createAsyncThunk('get/disputedTxnList', FetchDisputedTxnList);

export const FetchDisputedTxnSlice = createSlice({
	name: 'fetchDisputedTxnList',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchDisputedTxnList.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchDisputedTxnList.rejected.toString()]: setAPIError,
		[fetchDisputedTxnList.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchDisputedTxnSlice.name]: ReturnType<typeof FetchDisputedTxnSlice.reducer>;
}

export const fetchDisputedTxnSelector = (state: IStates): any => {
	return state[FetchDisputedTxnSlice.name] || {};
};

export const useDisputedTxnList = (): any => useSelector(fetchDisputedTxnSelector);

export const getDisputedTxnList =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchDisputedTxnList(params));
		return;
	};

export const resetDisputedTxnList =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchDisputedTxnSlice.actions.RESET());
		return;
	};
